export default class ImageService {
	static BaseUrl =
		"https://www.ueengordany.com/wp-content/uploads/beli-app/img";
	static ImageUrl = (path) => `${ImageService.BaseUrl}/${path}`;
	static ImageUrlLocal = (path) => path;
}
